import React, { Component, Fragment } from "react";
import { Card, CardBody, Table, Button ,Row} from "reactstrap";
import { Colxx, Separator } from "../../../components/shared/CustomBootstrap";
import {useSelector} from 'react-redux'
import axios from "axios";
import { BASE_URL } from "../../../constants/defaultValues";
import { apiCall } from "../../../functions/utils";

export default function ChangePassword() {
const authUser=useSelector((state)=>state.authUser)
const [state,setState]=React.useState({
    current_password:'',
    new_password:'',
    confirm_new_password:''
})
const [error,setError]=React.useState('')
const [success,setSuccess]=React.useState('')

const handleInput=(e)=>{
    setError('')
    setSuccess('')
    const key=e.target.name;
    const value=e.target.value;
    setState({
        ...state,
        [key]:value
    })
}
const handleChange=async(e)=>{
    e.preventDefault()
    setSuccess('')
    if(state.current_password==="" || state.new_password==="" || state.confirm_new_password===""){
        setError("All fields are required.")
        return
    }
    if(state.new_password!==state.confirm_new_password){
        setError("New Password & Confirm New Password does not match.")
        return
    }
    setError("")

    const body = {
        oldPassword:state.current_password,
        newPassword: state.new_password,
        newPassword_confirmation:state.confirm_new_password
    }
    let urlAppends = "/api/auth/updatePassword"

    const result=await apiCall(true,"POST",urlAppends,body,false,true,true)
    if(!result){
        setError("Password did not changed!")
        setSuccess('')
        
    }
    else{
        setSuccess("Password Successfully Changed!")
      
    }
    setState({
        new_password:'',
        current_password:'',
        confirm_new_password:''
    })
   
}

  return (
    <Fragment>
   
    <Row>
      <Colxx xxs="12">
      <Card className="dashboard-link-list">
        <CardBody>
            <div className="d-flex flex-column align-items-center justify-content-center">
            <div style={{width:"25%"}}>
                <input  type="password" value={state.current_password} onChange={handleInput} autoComplete="off" name="current_password"  className="form-control slider-inputs mt-3 input-height-small" placeholder="current password"/>
            </div>
            <div style={{width:"25%"}}>
                <input  type="password" value={state.new_password} onChange={handleInput} autoComplete="off" name="new_password"  className="form-control slider-inputs mt-3 input-height-small" placeholder="new password"/>
            </div>
            <div style={{width:"25%"}}>
                <input  type="password" value={state.confirm_new_password} onChange={handleInput} autoComplete="off" name="confirm_new_password"  className="form-control slider-inputs mt-3 input-height-small" placeholder="confirm new password"/>
            </div>
          
               {error.length>0 && <p style={{color:"red",marginTop:"10px",paddingTop:"10px"}}>{error}</p>}
               {success.length>0 && <p style={{color:"green",marginTop:"10px",paddingTop:"10px"}}>{success}</p>}

            <div style={{width:"21%",marginTop:"10px"}}>
            <button  className="slider-success-btn"  onClick={handleChange}>Change Password</button>
            </div>
            </div>
        </CardBody>
        </Card>
      </Colxx>
    </Row>
    
  </Fragment>
  )
}
